export enum SortDirection {
  Asc = 'asc',
  Desc = 'desc',
}
